import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _extends from 'babel-runtime/helpers/extends';

import PlayablePreviewer from '@pt/components/playablePreviewer.vue';
import qrcode from '@/components/Qrcode';
import { addQueryString } from '@com/utils/url';
import { language } from '@/common/storage';
import { mindworksInteractiveAdsUrl } from '@pt/config/host';
import { mapState } from 'vuex';

export default {
  props: {
    previewUrl: [String]
  },

  components: {
    PlayablePreviewer: PlayablePreviewer,
    qrcode: qrcode
  },

  data: function data() {
    return {};
  },


  computed: _extends({}, mapState({
    userInfo: function userInfo(state) {
      return state.user.info;
    }
  })),

  watch: {},

  mounted: function mounted() {},
  destroyed: function destroyed() {},


  methods: {
    cookPreviewUrl: function cookPreviewUrl(url, data) {
      if (!url) return '';
      var postData = data || {};
      var previewUrl = addQueryString(url, {
        preview: true,
        lang: language.get()
      });
      return addQueryString(mindworksInteractiveAdsUrl, _extends({
        url: previewUrl,
        mw_test: process.env.NODE_ENV === 'production' ? 0 : 1
      }, postData, {
        ptloading: 1, // 是否使用pt loading
        track_data: _JSON$stringify({
          uid: this.userInfo.id,
          env: process.env.NODE_ENV === 'production' ? 'p' : 't',
          sct: 'pt_project_download',
          cc: this.userInfo.cc || -1
        })
      }));
    }
  }
};